import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Navbar from "./components/Navbar"
import Board from "./components/Board";
import GameState from "./context/game/GameState";
import HowToPlay from "./components/HowToPlay";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import { useState,useEffect } from "react";


function App() {
  
  return (
    <GameState>
    <div className="bg-rose-50 overflow-hidden">
    <Router>
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Board/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/signup" element={<Signup/>}/>
        <Route path="/howtoplay" element={<HowToPlay/>}/>
        <Route path="/dashboard" element={<Dashboard/>}/>
      </Routes>
    </Router>
    </div>
    </GameState>
  );
}

export default App;
